import store from "store/store";

export const taskListSelectors = {
	error: (state = store.getState()) => state.tasks.content.error,
	content: (state = store.getState()) => state.tasks.content,
	isFetching: (state = store.getState()) => state.tasks.content.isFetching,
	isRefresh: (state = store.getState()) => state.tasks.content.isRefresh,
	awardTasks: (state = store.getState()) => state.tasks.award,
	proposalTasks: (state = store.getState()) => state.tasks.proposal,
};
